import "./MediaImage.scss";
import PropTypes from "prop-types";
import MediaLogo from "./MediaLogo";
import { GSAPAnimationMedia } from "components/GSAP";
import { GSAPAnimationMediaVideo } from "components/GSAP";
import { ITXPicture } from "components/ITXPicture";

export default function MediaImage({
  image,
  image4K,
  logo,
  size,
  showImageFullHeight,
  scaleAnimation,
}) {
  const notApplyParallax = showImageFullHeight || size !== "full_width";

  const getAnimation = () => {
    if (size === "full_width") {
      return "scale";
    } else if (size !== "full_width" && scaleAnimation) {
      return "extension";
    }
    return "none";
  };

  return (
    <GSAPAnimationMedia onScreenAnimation={getAnimation()}>
      <div
        className={`geco-media_image__wrapper ${
          size === "full_width"
            ? "geco-media_image__full"
            : "globalComponentContainer"
        } ${size === "full_width" && !showImageFullHeight ? "is-picture" : ""}`}
      >
        <GSAPAnimationMedia
          onScreenAnimation={notApplyParallax ? "" : "parallax"}
          className={`geco-media_image_inner ${
            notApplyParallax ? "" : "parallax"
          }`}
        >
          {logo.id && (
            <GSAPAnimationMediaVideo onScreenAnimation="logo" id={logo.id}>
              <MediaLogo
                id={logo.id}
                name={logo.name}
                logo_width={logo.width}
                logo_height={logo.height}
              />
            </GSAPAnimationMediaVideo>
          )}

          <ITXPicture
            className="geco-media_image"
            image={image}
            image_web={image}
            image_4k={image4K}
          />
        </GSAPAnimationMedia>
      </div>
    </GSAPAnimationMedia>
  );
}

MediaImage.propTypes = {
  image: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    alt: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.string,
  }),
  image4K: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    alt: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.string,
  }),
  logo: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    alt: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.string,
  }),
  size: PropTypes.oneOf(["default", "full_width", "full_screen"]),
  showImageFullHeight: PropTypes.bool,
  scaleAnimation: PropTypes.bool,
};
